var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"primary"},[_c('div',{staticStyle:{"display":"flex","padding-top":"50px"}},[_c('Robot',{staticStyle:{"width":"387px"}}),_c('SurveyClient',{staticStyle:{"width":"387px","margin-left":"20px"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }